const initialState = {
  //   totalCountData: [],
  //   isCountLoading: true,
  //   userTypeSelect: { label: "All", value: null },
  slackTab: false,
  tabIndex: "1",
  reload: false,
};
const slackTabReducer = (state = initialState, { type, payload }) => {
  // console.log("payoad",  payload);
  switch (type) {
    case "getSlackTab":
      state = { ...state, slackTab: payload };
      return state;
    case "getTabIndex":
      state = { ...state, tabIndex: payload };
      return state;
    case "setReload":
      state = { ...state, reload: payload };
      return state;
    default:
      return state;
  }
};
export default slackTabReducer;
